import React, { useState } from "react";
import Footer from "../Common/Footer";
import MobileMenu from "../Common/MobileMenu";
import Navbar from "../Common/Navbar";
import SubscriptionModal from "../Common/SubscriptionModal";
import SubscriptionSuccessModal from "../Common/SubscriptionSuccessModal";
import UnsubscriptionModal from "../Common/UnsubscriptionModal";
import { useMainPageDataSelector } from "../MainUi";
import EditProfileModal from "../MainUi/EditProfileModal";
import LoginModal from "../MainUi/LoginModal";
import VerifyOTPModal from "../MainUi/VerifyOTPModal";
import BuildfileErrorModal from "../Pages/AppDetailsPage/BuildfileErrorModal";
import Notification from "../Common/Notification";
import { useHomePageDataSelector } from "../Pages/HomePage";
import PagePopOver from "../Pages/HomePage/PagePopOver";
import { useLocation } from "react-router-dom";

export default ({ children }: any) => {
  const [sideMenuClicked, setSideMenuClicked] = useState(false);
  const [MSISDN, setMSISDN] = useState<string>("");
  const pageData = useMainPageDataSelector();
  const homePageData = useHomePageDataSelector();
  const location = useLocation();

  return (
    <>
      {pageData.showNotification && (
        <Notification notification={pageData.notificationMsg} />
      )}
      {location.pathname == "/" && homePageData.appOfTheWeek && <PagePopOver />}
      <Navbar
        sideMenuClicked={sideMenuClicked}
        setSideMenuClicked={setSideMenuClicked}
      />
      <MobileMenu
        sideMenuClicked={sideMenuClicked}
        setSideMenuClicked={setSideMenuClicked}
      />
      <main className="flex-shrink-0 without-left-menu">{children}</main>
      <LoginModal setMSISDN={setMSISDN} MSISDN={MSISDN} />
      <VerifyOTPModal />
      <EditProfileModal />
      <SubscriptionModal app={pageData.subscriptionApp} />
      <SubscriptionSuccessModal app={pageData.subscriptionApp} />
      <BuildfileErrorModal />
      <UnsubscriptionModal app={pageData.subscriptionApp} />
    </>
  );
};
